import { ConditionalFieldsContext } from '@src/orders/PermitFormSections/ConditionalFieldsContext';
import { useContext } from 'react';

export const useDisabledFields = () => {
  const { disabledFields } = useContext(ConditionalFieldsContext);

  const isFieldDisabled = (fieldName: string) => {
    return disabledFields.includes(fieldName);
  };

  return {
    isFieldDisabled,
    disabledFields,
  };
};
